<template>
<div class="page page_income">
	<!-- 头部 -->
	<div class="top">
		<div class="txt">总收入：￥<span class="cash">{{totalPrice}}</span></div>
	</div>
	<!-- 日期选择 -->
	<div class="riqi" @click="show = true">{{ date }}</div>
	<!-- 内容区 -->
	<van-tabs v-model="active" :border="false" @change="changeTab">
		<van-tab title="商城收入" :name="1"></van-tab>
		<!-- <van-tab title="云支付" :name="2"></van-tab>
		<van-tab title="约·看" :name="3"></van-tab> -->
		<!-- <van-tab title="视频" :name="4"></van-tab> -->
	</van-tabs>
    <!-- 列表 -->
    <!-- <div class="jiangren">
        <div class="con" v-for="income in dataList" :key="income.id">
            <div class="con_info clearfix">
                <div class="f-l con_info_r">
                    <div class="name">{{ income.title }}</div>
                    <div class="name">{{ income.price }}</div>
                    <div class="name">{{ income.date }}</div>
                </div>
            </div>
        </div>
    </div> -->
	<div class="list">
		<van-list v-model="loading" :finished="finished" finished-text="没有更多了" @load="getData" :immediate-check="false">
			<ul class="order" v-for="item in dataList" :key="item.id">
				<li class="item">
					<div class="item_l">
						<div class="bianhao">订单编号  {{item.order_num}}</div>
						<div class="time">{{item.date}}</div>
					</div>
					<div class="item_r price">{{item.type + '¥' +item.price}}</div>
				</li>
			</ul>
		</van-list>
	</div>
	<!-- 日期 弹层 -->
	<van-popup v-model="show" position="bottom">
		<van-datetime-picker
		v-model="currentDate"
		type="year-month"
		 @confirm="confirmDate" @cancel="show=false"
		/>
	</van-popup>
</div>
</template>

<script>
import Vue from 'vue';
import router from "../../../../.././router";
import {
    LOGOUT,
    LOGIN
} from "../../../../.././vuex/mutation_types";
import Bridge from '../../../../.././vuex/bridge.js'
Vue.prototype.$bridge = Bridge
var userAgent = navigator.userAgent
export default {
    // name: "map-index",
    data() {
        return {
            publicPath: process.env.BASE_URL,
            token: null,
			dataList: [],
			active: 1, // 1商城2云支付3约看4视频
			show: false,
			currentDate: new Date(), // 当天日期
			totalPrice: 0,
			date: this.format(new Date()), // 日期
			pages: {
				page: 1,
				size: 10
			},
			loading: false,
			finished: false
        };
    },
    
    created: function () {
        //根据userAgent判断是否在iOSAndroid客户端中
        if (userAgent && userAgent.indexOf('shidaijiyi') != -1) {
            this.isClient = true
            var params = {
                data: {
                    naviTitle: "收入明细"
                }
            };
            this.$bridge.callhandler("sdjy://navigation/style", params, data => {});
            //加载用户信息
            var memberParams = {
                'data': {
                }
            }
            this.$bridge.callhandler('sdjy://member/memberInfo', memberParams, (data) => {
                console.log(data)
                console.log('111')
                if (data.code == 200) {
                    this.token = data.result.token
                    this.getData()
                }
            })
            //注册方法，客户端重新进入页面刷新数据
            this.$bridge.registerhandler('sdjy://common/refreshPage', (data, responseCallback) => {
                // alert(JSON.stringify(data));
                responseCallback('refresh success')
            })
        } else {
            this.isClient = false
            // 获取列表
            this.token = this.$store.getters.token
            this.getData();
        }
    },
    methods: {
        // 获取列表
        getData() {
			if (this.token == null || this.token == undefined || this.token == '') {
                return
            }
            var param = {
				token: this.token,
				type: parseInt(this.active),
				time: this.date,
				page: this.pages.page,
				size: this.pages.size
            }
            this.$api.seller.income(param).then(res=>{
                if (res.code == 200) {
					var list = res.result.list
					this.totalPrice = res.result.total_prices
					for(var i in list) {
						this.dataList.push(list[i])
					}
					if(list.length == 0){
						this.finished = true
						return
					}   
                } else {
					this.finished = true
					this.$toast(res.message)
					return;
                }
			})
			this.pages.page++
			this.loading = false
		},
		// 确认日期
		confirmDate(value){
			console.log(value)
			this.date = this.format(value)
			this.show = false
			this.dataList = []
			this.pages.page = 1
			this.finished = false
			this.getData()
		},
		// 日期格式  data是日期对象  返回格式2020-05
		format(data){
			var year = data.getFullYear();
			var month = data.getMonth() + 1
			if(month.toString().length == 1){
				month = '0' + month
			}
			return year+'-'+month
		},
		// 切换分类
		changeTab(){
			this.dataList = []
			this.pages.page = 1
			this.finished = false
			this.getData()
		}
    }
};
</script>
<!-- Add "scoped" attribute to limit CSS to this component only -->

<style scoped></style>
